import { useCallback, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

import { REVIEW_TYPES } from "features/cdm/constants/reviewTypes";

// The OCF "add review" flow: the dialog open state + pending review type, the
// patient's locally-added (not-yet-submitted) OCF reviews, and the handler that
// adds one and asks the caller to open its preview (onReviewAdded).
export const useOcfReview = ({
  patientId,
  onReviewAdded,
  onReviewRemoved,
}) => {
  const [isAddOcfReviewDialogOpen, setIsAddOcfReviewDialogOpen] =
    useState(false);
  const [pendingOcfReviewType, setPendingOcfReviewType] = useState(
    REVIEW_TYPES.OCF_INITIAL
  );
  const [temporaryOcf, setTemporaryOcf] = useLocalStorage(
    `kinesin-temporary-ocf-${patientId}`,
    []
  );

  const openOcfReviewDialog = useCallback((reviewType) => {
    setPendingOcfReviewType(reviewType);
    setIsAddOcfReviewDialogOpen(true);
  }, []);

  const addOcfReview = useCallback(
    (data) => {
      setTemporaryOcf((prev) => [...prev, data]);
      onReviewAdded?.(data.id);
    },
    [setTemporaryOcf, onReviewAdded]
  );

  const removeOcfReview = useCallback(
    (reviewId) => {
      setTemporaryOcf((prev) => prev.filter((item) => item.id !== reviewId));
      onReviewRemoved?.();
    },
    [setTemporaryOcf, onReviewRemoved]
  );

  return {
    temporaryOcf,
    isAddOcfReviewDialogOpen,
    setIsAddOcfReviewDialogOpen,
    pendingOcfReviewType,
    openOcfReviewDialog,
    addOcfReview,
    removeOcfReview,
  };
};
